import { QueryObserverResult, useQuery } from '@tanstack/react-query'

import { getDataAccessRequestVerificationAttachmentSignedUrl } from 'services/data-access-requests'
import {
  DataAccessRequestQueryOptions,
  withDataAccessRequestsEnabled
} from 'services/data-access-requests/hooks/withDataAccessRequestsEnabled'
import { DataAccessRequestQueryKeys } from 'services/data-access-requests/queryKeys'
import type {
  GetDataAccessRequestVerificationAttachmentSignedUrlParams,
  GetDataAccessRequestVerificationAttachmentSignedUrlResponse
} from 'services/data-access-requests/types'
import type { ApiErrorResponse } from 'services/types'

export const useDataAccessRequestVerificationAttachmentSignedUrl = (
  params: GetDataAccessRequestVerificationAttachmentSignedUrlParams,
  options?: DataAccessRequestQueryOptions<GetDataAccessRequestVerificationAttachmentSignedUrlResponse, ApiErrorResponse>
): QueryObserverResult<GetDataAccessRequestVerificationAttachmentSignedUrlResponse, ApiErrorResponse> => {
  const { enabled: enabledOption, ...restOptions } = options ?? {}

  return useQuery<GetDataAccessRequestVerificationAttachmentSignedUrlResponse, ApiErrorResponse>({
    queryKey: DataAccessRequestQueryKeys.VerificationAttachmentSignedUrl(params),
    queryFn: () => getDataAccessRequestVerificationAttachmentSignedUrl(params),
    enabled: withDataAccessRequestsEnabled(!!params.requestId && !!params.fieldId && (enabledOption ?? true)),
    ...restOptions
  })
}
